/**
 * Format a dollar value as USD with dollar sign and two decimal places.
 * All values in the system are stored as DOLLARS (not cents).
 * Examples:
 *   fmtUSD(350000)    → "$350,000.00"
 *   fmtUSD(0)         → "$0.00"
 *   fmtUSD(null)      → "—"
 *   fmtUSD(8500.50)   → "$8,500.50"
 */
export function fmtUSD(dollars) {
  if (dollars == null || dollars === "" || isNaN(dollars)) return "—";
  return Number(dollars).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Compact format for large amounts (dashboard cards).
 * Examples:
 *   fmtUSDCompact(350000)    → "$350K"
 *   fmtUSDCompact(1500000)   → "$1.5M"
 *   fmtUSDCompact(500)       → "$500.00"
 */
export function fmtUSDCompact(dollars) {
  if (dollars == null || dollars === "" || isNaN(dollars)) return "—";
  const val = Number(dollars);
  if (val >= 1_000_000) return `$${(val / 1_000_000).toFixed(1)}M`;
  if (val >= 10_000) return `$${(val / 1_000).toFixed(0)}K`;
  if (val >= 1_000) return `$${(val / 1_000).toFixed(1)}K`;
  return val.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
